import { motion } from "framer-motion";

const chapters = [
  {
    number: "01",
    title: "Small science, big eyes",
    body: "Vinegar volcanoes. Sinking oranges. Shadows that grow. Simple experiments that turn your kitchen into a laboratory of wonder — no fancy kits, no shopping list.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_edu-marketplace-84/artifacts/mfr34mxq_2.jpeg",
    alt: "A child doing a simple baking-soda and vinegar science experiment at home",
  },
  {
    number: "02",
    title: "Stories that stay",
    body: "One story a week, told slowly. We'll guide you on how to read it, when to pause, and the tiny questions that turn a bedtime story into a lifelong love for books.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_edu-marketplace-84/artifacts/59nmhpi0_1.jpeg",
    alt: "A parent and child reading an illustrated storybook together on the floor",
  },
  {
    number: "03",
    title: "The question game",
    body: `"Why is the sky blue?" "Where does the sun sleep?" We'll send you the best conversations to have with your 3–5 year old — the kind that make their eyes go wide.`,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_edu-marketplace-84/artifacts/d70xw6mm_Child_asking_science_question_ou%E2%80%A6_202608011936.jpeg",
    alt: "A child pointing at the sky, asking a parent a curious question outdoors",
  },
];

export default function Manifesto() {
  return (
    <section
      className="pt-10 sm:pt-14 pb-24 sm:pb-32 bg-cream"
      id="manifesto"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mb-16 sm:mb-24"
        >
          <div className="text-xs sm:text-sm uppercase tracking-[0.24em] font-semibold text-terracotta mb-4">
            Three chapters · Twenty-one days
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
            Not a course. A gentle{" "}
            <span className="italic">daily companion.</span>
          </h2>
        </motion.div>

        <div className="space-y-20 sm:space-y-28">
          {chapters.map((c, i) => (
            <motion.article
              key={c.number}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center border-t border-ink/15 pt-12 sm:pt-16 ${
                i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
              }`}
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <div className="lg:col-span-6">
                <div className="relative aspect-[3/4] max-w-md">
                  <div className="absolute -inset-3 border border-ink/20" />
                  <img
                    src={c.image}
                    alt={c.alt}
                    className="relative w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="lg:col-span-6">
                <div className="font-serif text-7xl sm:text-8xl font-light text-ink/20 leading-none mb-4">
                  {c.number}
                </div>
                <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-ink mb-5">
                  {c.title}
                </h3>
                <p className="font-sans text-base sm:text-lg leading-relaxed text-ink/75 max-w-xl">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
